import { Injectable, ElementRef } from '@angular/core';
import * as moment from 'moment';

@Injectable()
export class DateTimeService {

  constructor() { }

  formatDateForApi(date: string) {
    return date.split('/').join('-');
  }

  formatDateForDisplay(date: string) {
    const d = new Date(date);
    const str_date = d.getDate() + '/' + Number(d.getMonth() + 1) + '/' + d.getFullYear();
    return str_date;
  }

  getDaysInterval(startDate: string, endDate: string) {
    const oneDay = 24 * 60 * 60 * 1000;
    const start = new Date(this.resolveDateForApi(startDate));
    const end = new Date(this.resolveDateForApi(endDate));

    const diff = Math.round(Math.abs((start.getTime() - end.getTime()) / oneDay));
    return diff;
  }

  getDay(date: string) {
    const x = new Date(date).getDay();

    switch (x) {
      case 1:
        return 'Monday';
      case 2:
        return 'Tuesday';
      case 3:
        return 'Wednesday';
      case 4:
        return 'Thursday';
      case 5:
        return 'Friday';
      case 6:
        return 'Saturday';
      default:
        return 'Sunday';
    }
  }

  getMonth(date: string) {
    const d = new Date(date);
    const monthNames = [ 'January', 'February', 'March', 'April', 'May', 'June',
      'July', 'August', 'September', 'October', 'November', 'December'
    ];

    return monthNames[d.getMonth()];
  }

  getMonth_Short(month: string) {
    return month.slice(0, 3);
  }

  getMonthNumber(month: string) {
    let monthNumb = -1;
    const monthNames = [ 'January', 'February', 'March', 'April', 'May', 'June',
      'July', 'August', 'September', 'October', 'November', 'December'
    ];

    for (let i = 0; i < monthNames.length; i++) {
      if (month == monthNames[i])
        monthNumb = i;
    }

    return monthNumb;
  }

  getWeeks(start: string, end: string) {
    var days = this.getDaysInterval(start, end);
    return days / 5;
  }

  isValidDate(date: any) {
    const validFormats = ['DD/MM/YYYY', 'DD/M/YYYY', 'D/MM/YYYY', 'D/M/YYYY'];
    return moment(date, validFormats, true).isValid();
  }

  getDatesInDateRange(start: string, end: string) {
    let allDates: Array<Date> = [];
    const endDate = new Date(this.resolveDateForApi(end));
    let startDate = new Date(this.resolveDateForApi(start));

    while (startDate <= endDate) {
      allDates.push(startDate);
      startDate = new Date(startDate.setDate(startDate.getDate() + 1));
    }

    return allDates;
  }

  displayDate(elementRef: ElementRef, date_model: any) {
    var _date: HTMLInputElement = elementRef.nativeElement;
    var year = date_model.year.toString();
    var day = date_model.day.toString().length == 1 ? '0' + date_model.day.toString() : date_model.day.toString();
    var month = date_model.month.toString().length == 1 ? '0' + date_model.month.toString() : date_model.month.toString();

    if (_date.value != ''){
      var date =  day.concat( '/' + month ).concat( '/' + year );
      _date.value = String(_date);
    }
  }

  turnStartDate(elementRef: ElementRef, start_model: any){
    var start: HTMLInputElement = elementRef.nativeElement;

    if (start.value != ''){
      var date =  start_model.day.toString()
        .concat( '/' + start_model.month.toString() )
        .concat( '/' + start_model.year.toString() );

      start.value = String(date);
    }

  }

  turnEndDate(elementRef: ElementRef, end_model: any){
    var end: HTMLInputElement = elementRef.nativeElement;

    if (end.value != ''){
      var date =  end_model.day.toString()
        .concat( '/' + end_model.month.toString() )
        .concat( '/' + end_model.year.toString() );

      end.value = String(date);
    }
  }

  resolveDateForApi(date_value: string) {
    var dateYear   = null;
    var dateMonth  = null;
    var dateDay    = null;
    const day_length = date_value.indexOf('/');
    const month_length = date_value.lastIndexOf('/');

    // if day is in double format
    if (day_length == 2) {
      // if month is in double format
      if (month_length == 5) {
        dateYear   = date_value.substring(6, 10);
        dateMonth  = date_value.substring(3, 5);
        dateDay    = date_value.substring(0, 2);
      }
      else if (month_length == 4) {
        dateYear   = date_value.substring(5, 10);
        dateMonth  = date_value.substring(3, 4);
        dateDay    = date_value.substring(0, 2);
      }
    }
    // if day is in single format
    else {
      // if month is in double format
      if (month_length == 4) {
        dateYear   = date_value.substring(5, 10);
        dateMonth  = date_value.substring(2, 4);
        dateDay    = date_value.substring(0, 1);
      }
      else {
        dateYear   = date_value.substring(4, 10);
        dateMonth  = date_value.substring(2, 3);
        dateDay    = date_value.substring(0, 1);
      }
    }

    return dateYear + '-' + dateMonth + '-' + dateDay;
  }

  resolveTermDate(term: any, start_element: any, end_element: any, start_model: any, end_model: any){
    const startYear  =  term.Begin_Date.substring(0,4);
    const startMonth =  term.Begin_Date.substring(5,7);
    const startDay   =  term.Begin_Date.substring(8,10);

    const endYear  =  term.End_Date.substring(0,4);
    const endMonth =  term.End_Date.substring(5,7);
    const endDay   =  term.End_Date.substring(8,10);

    end_element.nativeElement.value = `${endDay}/${endMonth}/${endYear}`;
    start_element.nativeElement.value   = `${startDay}/${startMonth}/${startYear}`;
  }


}



// WEBPACK FOOTER //
// C:/Users/TechTeam/Desktop/deploy/sims-web-prod/src/app/services/date-time/date-time.service.ts